import { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronRight, Plus } from 'lucide-react';
import useBoardStore from '../../../store/boardStore';
import FavoriteFolder from './FavoriteFolder';

export default function FavoritesSection({ activeBoardId, onNavigate }) {
  const { favoriteFolders, createFavoriteFolder } = useBoardStore();
  const [expanded, setExpanded] = useState(true);
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (creating && inputRef.current) inputRef.current.focus();
  }, [creating]);

  const submit = async () => {
    const trimmed = name.trim();
    if (trimmed) await createFavoriteFolder(trimmed);
    setName('');
    setCreating(false);
  };

  return (
    <div className="mb-3">
      <div className="flex items-center gap-1 px-4 py-1.5 text-xs font-semibold text-text-secondary uppercase tracking-wider">
        <button onClick={() => setExpanded(!expanded)} className="flex items-center gap-1 hover:text-text-primary">
          {expanded ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
          Favoritos
        </button>
        <div className="flex-1" />
        <button
          onClick={() => { setExpanded(true); setCreating(true); }}
          className="p-0.5 rounded hover:bg-white/10 hover:text-text-primary transition-colors"
          title="Nova pasta"
        >
          <Plus className="w-3.5 h-3.5" />
        </button>
      </div>
      {expanded && (
        <div>
          {favoriteFolders.map((f) => (
            <FavoriteFolder key={f.id} folder={f} activeBoardId={activeBoardId} onNavigate={onNavigate} />
          ))}
          {creating && (
            <div className="px-4 py-1">
              <input
                ref={inputRef}
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={submit}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') submit();
                  if (e.key === 'Escape') { setName(''); setCreating(false); }
                }}
                placeholder="Nome da pasta..."
                className="w-full bg-main border border-accent/50 rounded px-2 py-1 text-xs text-text-primary outline-none"
              />
            </div>
          )}
          {!creating && favoriteFolders.length === 0 && (
            <div className="px-4 py-1 text-[11px] text-text-secondary/60 italic">
              Crie uma pasta e arraste boards pra dentro.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
